exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.document-line[data-v-763b0c8d] {\n    border: 0;\n}\n.document-allocations[data-v-763b0c8d] {\n    background-color: white;\n}\n.contractor-table-field[data-v-763b0c8d]{\n    max-width: 100px;\n}\n.label-danger[data-v-763b0c8d] {\n    cursor: pointer;\n}\n.modal-body[data-v-763b0c8d] {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n}\n.text-green[data-v-763b0c8d] {\n    color: green;\n}\n.text-red[data-v-763b0c8d] {\n    color: red;\n}\n\n", ""]);

// exports
